import React from "react";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";
import moment from "moment";

interface IProps {
    data: Array<Record<string, any>>;
    columns: Array<Record<string, any>>;
    description: string;
    compileDate: string;
}

export default function PurchaseOrderOutstandingItemsTable(props: IProps) {
    function formatDisplay(type: string, value: string) {
        let newValue = value !== null && value !== undefined ? value : "";

        if (newValue !== "") {
            switch (type) {
                case "currency":
                    newValue = formatReportCurrency(value);
                    break;
                case "decimal":
                    newValue = Number(value).toFixed(2);
                    break;
                case "datetime":
                    newValue = moment.utc(value, "YYYY-MM-DD HH:mm:ss")?.local()?.format("LLL");
                    break;
                default:
                    break;
            }
        }

        return newValue;
    }

    function cellData(columnId: string, cellValue: string, displayType: string) {
        switch (columnId) {
            default:
                return formatDisplay(displayType, cellValue);
        }
    }

    function rowClassNames(row: any) {
        return classNames({
            "report-table-row": !row.original?.subRows,
            "report-table-row-total": !!row.original?.subRows,
        });
    }

    function cellClassNames(cell: any, isRowLocked: boolean) {
        const original = cell.row?.original;
        const isClickableRow = !cell.isGrouped && !cell.isAggregated;

        return classNames({
            "report-table-row-locked": isRowLocked,
            "report-table-cell-clickable":
                isClickableRow &&
                ((cell.column.id === "purchase_order_number" && original?.purchase_order_number)),
        });
    }

    function cellOnClick(cell: any) {
        if (!cell || cell.isGrouped || cell.isAggregated) {
            return null;
        }

        const original = cell.row?.original;

        if (cell.column.id === "purchase_order_number" && original?.purchase_order_number) {
            return window.open(`/admin/settings/purchase-orders/${original?.purchase_order_id}`);
        }

        return null;
    }

    function footerData(columnId: string, footerRow?: Record<string, any>) {
        if (!footerRow) {
            return null;
        }

        switch (columnId) {
            case "cost":
                return formatDisplay("currency", String(footerRow[columnId] ?? 0));
            default:
                return (footerRow[columnId] as string) ?? null;
        }
    }

    return (
        <BaseReportTable
            data={props.data}
            columns={props.columns}
            description={props.description}
            compileDate={props.compileDate}
            cellOnClick={cellOnClick}
            cellData={cellData}
            rowClassNames={rowClassNames}
            cellClassNames={cellClassNames}
            footerData={footerData}
            expanding={true}
            expandingColumn="type"
        />
    );
}
